import React, { Component } from "react";
import MfaCodeVerification from "./MfaCodeVerification";
import Input from "../components/inputs/input";
import Password from "../components/inputs/password";
import Footer from "../main/footer";
import Banner from "../index/index-banner";
import Alert from "sweetalert2";
import AppContext from "../appContext";
import "../index/index.css";

import logobanner from "../index/img/logo-banner-2021.png";

/**
 * Fluxo MFA integrado com backend
 *
 * 1. Usuario submete email + senha -> POST /mfa_solicitacao.php
 * 2. Backend valida credenciais e envia codigo por e-mail, retorna tokenMFA
 * 3. Tela de verificacao de codigo e exibida diretamente
 * 4. Usuario insere o codigo -> POST /mfa_token.php (usuario, codigoOtp, tokenMFA)
 * 5. Mensagem "Codigo validado" e exibida e redireciona para /home
 *
 * Acesse via /mfa-demo
 */
class MfaDemo extends Component {
  static contextType = AppContext;

  constructor(props) {
    super(props);

    this.state = {
      email: "",
      password: "",
      showCodeVerification: false,
      disabled: false,
      tokenMFA: null,
    };

    this.codeVerificationRef = React.createRef();

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleCodeVerify = this.handleCodeVerify.bind(this);
    this.handleResendCode = this.handleResendCode.bind(this);
  }

  componentDidMount() {
    sessionStorage.removeItem("token");
    sessionStorage.removeItem("session_token");
    sessionStorage.removeItem("grant_token");
    localStorage.removeItem("emailLogin");
  }

  convertJWT(token) {
    var base64Url = token.split(".")[1];
    var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    var jsonPayload = decodeURIComponent(
      atob(base64)
        .split("")
        .map(function (c) {
          return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join(""),
    );
    return JSON.parse(jsonPayload);
  }

  handleChange(e) {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  }

  handleSubmit(e) {
    e.preventDefault();
    const { email, password } = this.state;

    if (!(email && password)) {
      return;
    }

    this.setState({ disabled: true });

    document.getElementById("main-body").style.pointerEvents = "none";
    document.getElementById("overlay_login").style.display = "block";

    if (this.context && this.context.showLoading) {
      this.context.showLoading("Entrando...");
    }

    this.requestMfaCode(email, password);
  }

  requestMfaCode(email, password) {
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ usuario: email.toLowerCase().trim(), senha: password }),
    };

    fetch(process.env.REACT_APP_LABS_API + "mfa_solicitacao.php", requestOptions)
      .then(response => response.json())
      .then(jsonText => {
        document.getElementById("overlay_login").style.display = "none";
        document.getElementById("main-body").style.pointerEvents = "";

        if (this.context && this.context.hideLoading) {
          this.context.hideLoading();
        }

        if (jsonText.status === "erro") {
          this.setState({ disabled: false });

          if (jsonText.code === 400 || jsonText.code === 401) {
            Alert.fire({
              text: "Usuário ou senha incorretos. Verifique suas credenciais e tente novamente.",
              icon: "warning",
              title: "Aviso",
              confirmButtonColor: "#00518b",
            });
          } else if (jsonText.code === 403) {
            Alert.fire({
              text: jsonText.message || "Acesso negado.",
              icon: "warning",
              title: "Aviso",
              confirmButtonColor: "#00518b",
            });
          } else {
            Alert.fire({
              text: "Erro interno. Favor tentar novamente mais tarde.",
              icon: "warning",
              title: "Aviso",
              confirmButtonColor: "#00518b",
            });
          }
        } else {
          this.setState({
            tokenMFA: jsonText.tokenMFA,
            showCodeVerification: true,
            disabled: false,
          });
        }
      })
      .catch(error => {
        console.error("Erro na solicitação MFA:", error);
        document.getElementById("overlay_login").style.display = "none";
        document.getElementById("main-body").style.pointerEvents = "";

        if (this.context && this.context.hideLoading) {
          this.context.hideLoading();
        }

        this.setState({ disabled: false });

        Alert.fire({
          text: "Erro de conexão. Favor tentar novamente mais tarde.",
          icon: "error",
          title: "Erro",
          confirmButtonColor: "#00518b",
        });
      });
  }

  handleCodeVerify(code) {
    const { email, tokenMFA } = this.state;

    if (this.context && this.context.showLoading) {
      this.context.showLoading("Verificando código...");
    }

    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        usuario: email.toLowerCase().trim(),
        codigoOtp: code,
        tokenMFA: tokenMFA,
      }),
    };

    fetch(process.env.REACT_APP_LABS_API + "mfa_token.php", requestOptions)
      .then(response => response.json())
      .then(jsonText => {
        if (this.context && this.context.hideLoading) {
          this.context.hideLoading();
        }

        if (jsonText.status === "erro") {
          // Código inválido ou erro - delega tratamento ao MfaCodeVerification
          if (this.codeVerificationRef.current) {
            this.codeVerificationRef.current.setError(true);
          }
          return;
        }

        // Código válido - salva tokens e redireciona
        localStorage.setItem("isUsuarioSemCnpj", true);
        sessionStorage.setItem("token", jsonText.access_token);
        sessionStorage.setItem("session_token", jsonText.session_token);
        sessionStorage.setItem("grant_token", jsonText.grant_token);
        localStorage.setItem("token", jsonText.access_token);
        localStorage.setItem("session_token", jsonText.session_token);
        localStorage.setItem("grant_token", jsonText.grant_token);

        if (this.codeVerificationRef.current) {
          this.codeVerificationRef.current.setValidated(true);
        }

        setTimeout(() => {
          window.location.href = "/home";
        }, 1500);
      })
      .catch(error => {
        console.error("Erro na verificação MFA:", error);
        if (this.context && this.context.hideLoading) {
          this.context.hideLoading();
        }
        Alert.fire({
          text: "Erro de conexão. Tente novamente mais tarde.",
          icon: "error",
          title: "Erro",
          confirmButtonColor: "#00518b",
        });
      });
  }

  handleResendCode() {
    const { email, password } = this.state;

    if (this.context && this.context.showLoading) {
      this.context.showLoading("Reenviando código...");
    }

    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ usuario: email.toLowerCase().trim(), senha: password }),
    };

    fetch(process.env.REACT_APP_LABS_API + "mfa_solicitacao.php", requestOptions)
      .then(response => response.json())
      .then(jsonText => {
        if (this.context && this.context.hideLoading) {
          this.context.hideLoading();
        }

        if (jsonText.status === "erro") {
          Alert.fire({
            text: "Erro ao reenviar o código. Tente novamente.",
            icon: "warning",
            title: "Aviso",
            confirmButtonColor: "#00518b",
          });
          return;
        }

        // Atualiza o tokenMFA com o novo retornado
        this.setState({ tokenMFA: jsonText.tokenMFA });

        Alert.fire({
          title: "Código reenviado!",
          text: `Um novo código foi enviado para ${email}`,
          icon: "info",
          confirmButtonColor: "#0394db",
          timer: 2000,
          showConfirmButton: false,
        });
      })
      .catch(error => {
        console.error("Erro ao reenviar código:", error);
        if (this.context && this.context.hideLoading) {
          this.context.hideLoading();
        }
        Alert.fire({
          text: "Erro de conexao ao reenviar o codigo.",
          icon: "error",
          title: "Erro",
          confirmButtonColor: "#00518b",
        });
      });
  }

  renderLoginForm() {
    const { email, password } = this.state;

    return (
      <>
        <h3 className="login-signin__title">Conecte-se</h3>

        <div className="alert" style={{ fontSize: "14px", backgroundColor: "#FFFDE7", color: "#F57F17", borderColor: "#FFE082", fontWeight: 500 }}>
          <p className="m-1">A partir de agora, o login no Conecta utiliza autenticação de dois fatores para maior segurança da sua conta.</p>
        </div>

        <form className="login-signin__form" onSubmit={this.handleSubmit}>
          <div className="login-signin__form-row">
            <Input
              autoFocus={true}
              label="E-mail*"
              type="email"
              width="100%"
              title="email@email.com.br"
              name="email"
              pattern="([a-zA-Z0-9._%+-]+@[A-Za-z0-9.-]+\.[a-zA-Z]{2,3}$)"
              id="email-cpf"
              placeholder="email@email.com.br"
              required={true}
              value={email}
              onChange={this.handleChange}
            />
          </div>

          <div className="login-signin__form-row">
            <Password
              label="Senha"
              width="100%"
              name="password"
              id="password"
              placeholder="Senha"
              required={true}
              type="password"
              value={password}
              onChange={this.handleChange}
            />
            <br />
          </div>

          <div className="login-signin__form-div-button">
            <button className="login-signin__form-button is--blue" type="submit" title="Entrar" disabled={this.state.disabled}>
              Entrar
            </button>
          </div>

          <div className="mb-3 text-center">
            <a href="/resetpassword" className="login-signin__form-link">
              Esqueci a senha
            </a>
          </div>
        </form>

        <div className="login-signin__sign-up">
          <p className="login-signin__sign-up--text">Ainda não tem uma conta?</p>
          <a href="/signup" className="login-signin__sign-up--link">
            Cadastre-se aqui
          </a>
        </div>

        <div className="login-signin__tutorial">
          <p className="login-signin__tutorial--text">Ficou com dúvidas no cadastro?</p>
          <a href="https://www.youtube.com/watch?v=example" target="_blank" rel="noopener noreferrer" className="login-signin__tutorial--link">
            Assista ao tutorial
          </a>
        </div>
      </>
    );
  }

  renderCodeVerification() {
    const { email } = this.state;

    return (
      <MfaCodeVerification
        ref={this.codeVerificationRef}
        key="mfa-code-verification"
        email={email || "useremail@gmail.com"}
        onVerify={this.handleCodeVerify}
        onResendCode={this.handleResendCode}
      />
    );
  }

  render() {
    const { showCodeVerification } = this.state;

    function closeLogin() {
      var element = document.getElementById("loginMobile");
      element.classList.remove("is--active");
      var element1 = document.getElementById("loginGeral");
      element1.classList.remove("has--no-scroll");
      document.querySelector(".login-banner__main").style.display = "";
    }

    return (
      <div className="login" id="main-body">
        <main className="container login-main">
          <section>
            <div className="login-top" id="loginGeral">
              <Banner />

              <div className="login-signin__wrapper">
                <div className="login-signin js--login-mobile" id="loginMobile">
                  <div className="login-signin__container">
                    <div className="login-signin__logo">
                      <a href="/" className="login-signin__logo-link">
                        <img alt="" src={logobanner} className="login-signin__logo-image" />
                      </a>
                    </div>

                    <div className="login-signin__back-button js--close-login" onClick={closeLogin}>
                      <svg xmlns="http://www.w3.org/2000/svg" width="21.31" height="14.994" viewBox="0 0 21.31 14.994">
                        <path
                          id="np_arrow_2410576_000000"
                          className="cls-1"
                          d="M39,44.133l6.709-5.525a.807.807,0,0,0,.1-1.116.824.824,0,0,0-1.116-.1L39.287,41.84V23.786a.789.789,0,0,0-1.579,0V41.84l-5.414-4.452a.827.827,0,0,0-1.116.1.8.8,0,0,0,.1,1.116l6.709,5.525a.825.825,0,0,0,1.011,0Z"
                          transform="translate(44.307 -31.001) rotate(90)"
                          fill="#0066b3"
                        />
                      </svg>
                    </div>

                    {showCodeVerification
                      ? this.renderCodeVerification()
                      : this.renderLoginForm()
                    }
                  </div>
                </div>
              </div>
            </div>
            <div id="overlay_login" className="overlay_login"></div>
          </section>
        </main>
        <Footer />
      </div>
    );
  }
}

export default MfaDemo;
